import React from 'react';
import { Shield } from 'lucide-react';
import Header from './components/Header4';
import Footer from './components/Footer4';

const PrivacyPolicy = () => {
    const sections = [
        {
            title: '1. Information We Collect',
            content: 'We collect information that you provide directly to us, including your name, email address, postal address, phone number, and payment information when you make a purchase, create an account, subscribe to our newsletter, or contact us. We also automatically collect certain information about your device when you use our website, including your IP address, browser type, operating system, and browsing behavior.'
        },
        {
            title: '2. How We Use Your Information',
            content: 'We use the information we collect to process your orders, communicate with you about your purchases, send you marketing communications (with your consent), improve our website and services, prevent fraud and enhance security, and comply with legal obligations. We may also use your information to personalize your shopping experience and provide customer support.'
        },
        {
            title: '3. Information Sharing',
            content: 'We do not sell, trade, or rent your personal information to third parties. We may share your information with service providers who assist us in operating our website, conducting our business, or servicing you (such as payment processors, shipping carriers, and email service providers). These third parties are obligated to keep your information confidential.'
        },
        {
            title: '4. Data Security',
            content: 'We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. All payment transactions are processed through secure, encrypted channels. However, no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.'
        },
        {
            title: '5. Cookies & Tracking',
            content: 'We use cookies and similar tracking technologies to enhance your browsing experience, analyze website traffic, and personalize content. You can control cookie settings through your browser preferences. Essential cookies are required for the website to function properly.'
        },
        {
            title: '6. Your Rights',
            content: 'You have the right to access, correct, or delete your personal information. You can update your account information at any time through your profile settings. You may also request a copy of your data or ask us to restrict processing. To exercise these rights, please contact us at privacy@neela.in.'
        },
        {
            title: '7. Third-Party Links',
            content: 'Our website may contain links to third-party sites. We are not responsible for the privacy practices of these sites. We encourage you to read the privacy policies of any linked websites before providing personal information.'
        },
        {
            title: '8. Children\'s Privacy',
            content: 'Our services are not directed to individuals under the age of 18. We do not knowingly collect personal information from children. If we learn that we have collected information from a child under 18, we will take steps to delete it promptly.'
        },
        {
            title: '9. Changes to This Policy',
            content: 'We may update this privacy policy from time to time. We will notify you of significant changes by posting a notice on our website or sending you an email. Your continued use of our services after changes constitutes acceptance of the updated policy.'
        },
        {
            title: '10. Contact Us',
            content: 'If you have questions about this privacy policy or our data practices, please contact us at privacy@neela.in or write to us at 42 Marine Drive, Mumbai, Maharashtra 400001, India.'
        },
    ];

    return (
        <div className="w-full min-h-screen bg-white" style={{ fontFamily: "'Work Sans', sans-serif" }}>
            <Header />
            <link href="https://fonts.googleapis.com/css2?family=Work+Sans:wght@300;400;500;600;700&display=swap" rel="stylesheet" />

            <main className="pt-20 md:pt-24">
                {/* Hero */}
                <div className="bg-[#F0F7FA] py-10 md:py-16 px-4 text-center">
                    <div className="w-12 h-12 bg-[#1B4965] rounded-full flex items-center justify-center mx-auto mb-4">
                        <Shield className="w-6 h-6 text-white" />
                    </div>
                    <h1 className="text-3xl md:text-4xl font-semibold text-[#1B4965] mb-3">Privacy Policy</h1>
                    <p className="text-sm text-[#6B7280]">Last updated: March 2026</p>
                </div>

                <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
                    <div className="space-y-8">
                        {sections.map((section, i) => (
                            <div key={i}>
                                <h2 className="text-base font-semibold text-[#1B4965] mb-3">{section.title}</h2>
                                <p className="text-sm text-[#6B7280] leading-relaxed">{section.content}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default PrivacyPolicy;
